export enum EnergyLabel {
    Aplusplusplusplus = 'A++++',
    Aplusplusplus = 'A+++',
    Aplusplus = 'A++',
    Aplus = 'A+',
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
}
